// Konfiguracja tabeli „Sprzedaż rozpoczęta” na karcie klienta (Panel Handlowca)

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Parametry (opcje nad tabelą) – brak
 */
export const getTraderClientCardSalesTableParameters = (
): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: Nazwa oferty, numer oferty, data oferty, wartość (zł), status
 */
export const getTraderClientCardSalesTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'text',
      label: t('Nazwa oferty'),
      field_symbol: 'offer_name',
      align: 'left',
      tooltip: null,
      size: 200
    },
    {
      type: 'text',
      label: t('Numer oferty'),
      field_symbol: 'offer_number',
      align: 'center',
      tooltip: null,
      size: 120
    },
    {
      type: 'date',
      label: t('Data oferty'),
      field_symbol: 'offer_date',
      align: 'center',
      tooltip: null,
      size: 120
    },
    {
      type: 'text',
      label: t('Wartość (zł)'),
      field_symbol: 'value',
      align: 'right',
      tooltip: null,
      size: 120
    },
    {
      type: 'status',
      label: t('Status'),
      field_symbol: 'status',
      align: 'center',
      tooltip: null,
      size: 120
    }
  ];
};

/**
 * Akcje tabeli – brak
 */
export const getTraderClientCardSalesTableActions = (
): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych (endpoint /trader/sales)
 */
export const traderClientCardSalesTableLoadDataParams: ILoadDataParam = {
  get_url: '/trader/sales', // todo align endpoint with be
  params_list: null
};
